export default __webpack_public_path__ + "static/media/logo.1465f72d.svg";